import { useContext } from "react";
import { FormControlContext } from "../../FormControl/FormControlContext";
import { SelectBase, SelectBaseProps } from "../base/SelectBase";

export type SelectProps<TOption = unknown> = SelectBaseProps<TOption> & {
  style?: React.CSSProperties;
  css?: any;
  formatOptionLabel?: (option: TOption) => React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  dataCy?: string;
  placeholderFontSize?: string;
  noOptionsMessage?: string;
  renderValuesOutside?: boolean;
};

export const Select = <TOption,>({
  name: nameProps,
  disabled: disabledProps,
  onBlur: onBlurProps,
  onChange: onChangeProps,
  value: valueProps,
  style,
  formatOptionLabel,
  leftIcon,
  rightIcon,
  dataCy,
  placeholderFontSize,
  noOptionsMessage,
  ...props
}: SelectProps<TOption>) => {
  const formControl = useContext(FormControlContext);
  const name = nameProps ?? formControl.name;
  const disabled = disabledProps ?? formControl.disabled;
  const onBlur = onBlurProps ?? formControl.onBlur;
  const onChange = onChangeProps ?? formControl.onChange;
  const value = valueProps ?? formControl.value ?? null;
  const isDirty = !!formControl.error;
  const isFieldError = !!formControl.error;

  return (
    <SelectBase
      dataCy={dataCy}
      style={style}
      {...props}
      name={name}
      disabled={disabled}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      isFieldError={isFieldError}
      isDirty={isDirty}
      formatOptionLabel={formatOptionLabel}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      placeholderFontSize={placeholderFontSize}
      noOptionsMessage={noOptionsMessage}
    />
  );
};

Select.displayName = "Select";
